import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent {
  breadcrumbs: { label: string, path: string }[] = [];
  notHome = false;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.breadcrumbs = this.getBreadcrumbs(this.activatedRoute.root);
    });
    // check if url is /home
    this.router.events.subscribe((val) => {
      if (this.router.url === '/home') {
        this.notHome = false;
      } else {
        this.notHome = true;
      }
    });
  }

  getBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: { label: string, path: string }[] = []): { label: string, path: string }[] {
    const routeConfig = route.routeConfig;
    const label = routeConfig && routeConfig.data ? routeConfig.data['title'] : '';
    const path = routeConfig && routeConfig.path ? routeConfig.path : '';

    const nextUrl = `${url}/${path}`;
    const breadcrumb = {
      label: label,
      path: nextUrl
    };
    const newBreadcrumbs = breadcrumb.label ? [...breadcrumbs, breadcrumb] : [...breadcrumbs];

    if (route.firstChild) {
      return this.getBreadcrumbs(route.firstChild, nextUrl, newBreadcrumbs);
    }

    return newBreadcrumbs;
  }
}
